import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch } from "react-redux";
import { FaFile, FaKeyboard, FaPalette, FaTimes } from "react-icons/fa";
import { Colorpicker } from "../Colorpicker";
import {
  deleteFolderOrTodo,
  getFoldersFromLocalStorage,
  renameFolderOrTodo,
  setFileOrderIds,
  setFiles,
  setFolderOrderIds,
  setShortCut,
} from "../../redux/folder/folderSlice";
import {
  delete_folder_thunk,
  update_folder_thunk,
  update_shortcut_thunk,
} from "../../redux/folder/folderThunk";
import { setErrorAlert } from "../../redux/alert/alertSlice";
import { update_user_thunk } from "../../redux/auth/authThunk";
import { useSelector } from "react-redux";
import { clearFiles } from "../../redux/todo/todoSlice";
import { setOpenTabs } from "../../redux/opentab/opentabSlice";
import { create_or_update_opentab_thunk } from "../../redux/opentab/opentabThunk";
import { setUserShortcut } from "../../redux/auth/authSlice";

export default function ContextMenu({
  renameText,
  setRenameText,
  renameId,
  setRenameId,
  token,
  fileType,
  updateTodoInOpenTabs,
  deleteTodoFromOpenTabs,
  changeBackgroundColor,
  contextMenu,
  closeContextMenu,
  contextMenuRef,
  hexValue,
  setHexValue,
  isDragging,
  setIsDragging,
  showColorPicker,
  setShowColorPicker,
  tabRenameInputRef,
  setShortCutFileRef,
  files,
  folders,
  activeTab,
  setActiveTab,
}) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const folderOrderIds = useSelector((state) => state.folder.folderOrderIds);
  const fileOrderIds = useSelector((state) => state.folder.fileOrderIds);
  const [showModal, setShowModal] = useState(false);

  const [isColorPickerModal, setIsColorPickerModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const activeFolder = useSelector((state) => state.folder.activeFolder);
  const openTabs = useSelector((state) => state.opentab.openTabs);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 640);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleRename = (itemData) => {
    if (renameText.trim()) {
      let data = {
        id: renameId,
        name: renameText,
      };
      if (itemData.type === fileType[1]) {
        updateTodoInOpenTabs(data);
      }
      dispatch(renameFolderOrTodo({ itemData, renameText }));

      if (itemData.type === fileType[1]) {
        dispatch(setFiles(itemData.parentId));
      }
      dispatch(update_folder_thunk({ data: data, token }));
      setRenameId(null);
      setRenameText("");
    }
    closeContextMenu();
  };

  const handleDelete = (data) => {
    dispatch(deleteFolderOrTodo({ data }));
    if (data.type === fileType[1]) {
      deleteTodoFromOpenTabs(data.id);
      dispatch(setFiles(data.parentId));
      const folderId = data.parentId || "default-folder";
      const filterFileOrderIds =
        fileOrderIds[folderId]?.filter((id) => id !== data.id) || [];
      dispatch(
        setFileOrderIds({
          folderId,
          fileIds: filterFileOrderIds,
        })
      );
    } else if (data.type === fileType[0]) {
      if (activeFolder === data.id) {
        dispatch(clearFiles());
      }

      if (data.children?.length > 0) {
        // Get all child IDs to filter out
        const childIds = data.children.map((child) => child.id);
        // Filter out all tabs related to children in one go
        const filteredTabs = openTabs.filter(
          (tab) => !childIds.includes(tab.id)
        );

        // Update tabs state once
        dispatch(setOpenTabs(filteredTabs));

        if (childIds.includes(activeTab)) {
          setActiveTab("");
        }

        // Update open tabs in backend
        dispatch(
          create_or_update_opentab_thunk({
            data: filteredTabs,
            token: token,
          })
        );
      }

      const filterFolderOrderIds =
        folderOrderIds?.filter((id) => id !== data.id) || [];
      dispatch(setFolderOrderIds(filterFolderOrderIds));
    }
    dispatch(delete_folder_thunk({ id: data.id, token }));
    closeContextMenu();
  };

  const handleColorChange = (color) => {
    let data = {
      id: contextMenu?.item?.id,
      backgroundColor: color,
    };
    changeBackgroundColor(data, false);
    if (contextMenu?.item) {
      const updatedItem = { ...contextMenu.item, color: color };
    }
  };

  if (!contextMenu) return null;
  const menuStyle = {
    position: "fixed",
    left: `${contextMenu.x}px`,
    zIndex: 1000,
  };

  if (contextMenu.openUpward) {
    menuStyle.bottom = `${window.innerHeight - contextMenu.y + 10}px`;
  } else {
    menuStyle.top = `${contextMenu.y}px`;
  }

  const handleRemoveShortcut = () => {
    const data = {
      id: contextMenu.item.id,
      shortcut: null,
    };

    if (contextMenu?.item?.id === "default-folder") {
      dispatch(setUserShortcut(null));
      dispatch(getFoldersFromLocalStorage());

      dispatch(
        update_user_thunk({
          data: { defaultFolderShortcut: null },
          token,
        })
      );
    } else {
      dispatch(setShortCut({ item: contextMenu.item, shortcut: null }));
      dispatch(update_shortcut_thunk({ data, token }));
    }
    if (contextMenu.item.type === fileType[1]) {
      dispatch(setFiles(contextMenu.item.parentId));
    }

    closeContextMenu();
  };
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.1 }}
        // ref={(el) => (contextMenu.ref = el)}
        ref={contextMenuRef}
        style={menuStyle}
        id="sidebar-content-menu"
        className="bg-gray-800/95 shadow-md shadow-gray-700 backdrop-blur-sm text-white  rounded-lg p-1.5 min-w-[180px] border border-gray-700/50 "
      >
        {renameId === contextMenu.item.id ? (
          <input
            type="text"
            ref={tabRenameInputRef}
            value={renameText}
            onChange={(e) => setRenameText(e.target.value)}
            onKeyDown={(e) =>
              e.key === "Enter" && handleRename(contextMenu?.item)
            }
            className="w-full px-3 bg-transparent py-2 rounded-md  text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 placeholder-gray-400"
            autoFocus
          />
        ) : (
          <>
            {contextMenu.item?.type === fileType[1] && (
              <>
                <button
                  onClick={() => {
                    if (window.innerWidth < 768) {
                      setShowModal(true);
                    } else {
                      setShowColorPicker(!showColorPicker);
                    }
                  }}
                  className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-gray-700/50 bg-gray-800/95 rounded-md transition-colors"
                >
                  <div className="flex items-center gap-2 flex-1">
                    <FaPalette className="text-gray-400" size={12} />
                    <span>Choose Color</span>
                    <div
                      className="w-4 h-4 rounded-full ml-2"
                      style={{ backgroundColor: hexValue }}
                    />
                  </div>
                </button>
                <div className="flex w-full items-center gap-2 px-3 py-2 text-sm bg-gray-800/95 rounded-md">
                  <FaKeyboard className="text-gray-400" size={12} />
                  <input
                    type="text"
                    placeholder={
                      contextMenu.item.shortcut
                        ? contextMenu.item.shortcut
                        : "Set shortcut key (a-z)"
                    }
                    ref={setShortCutFileRef}
                    maxLength={1}
                    className="w-full bg-transparent text-white focus:outline-none"
                    // value={contextMenu.item.shortcut || ""}
                    onChange={(e) => {
                      const key = e.target.value.toLowerCase();
                      if (key.length === 1 && key.match(/[a-z]/i)) {
                        const isShortcutTaken = files.some(
                          (file) => file.shortcut === key
                        );

                        if (isShortcutTaken) {
                          dispatch(
                            setErrorAlert("This shortcut is already in use")
                          );
                          return;
                        }
                        dispatch(
                          setShortCut({ item: contextMenu.item, shortcut: key })
                        );

                        let data = {
                          id: contextMenu.item.id,
                          shortcut: key,
                        };
                        if (contextMenu.item.type === fileType[1]) {
                          dispatch(setFiles(contextMenu.item.parentId));
                        }
                        dispatch(update_shortcut_thunk({ data, token }));
                        closeContextMenu();
                      }
                    }}
                  />
                </div>
                {contextMenu.item.shortcut && (
                  <button
                    onClick={handleRemoveShortcut}
                    className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-gray-700/50 bg-gray-800/95 text-yellow-400 rounded-md transition-colors"
                  >
                    <FaTimes className="text-yellow-400" size={12} />
                    Remove Shortcut
                  </button>
                )}
                {showColorPicker && window.innerWidth >= 768 && (
                  <div
                    style={{
                      position: "absolute",
                      ...(contextMenu.openUpward
                        ? {
                            bottom: "0%",
                            marginBottom: "5px",
                            left: "100%",
                            marginLeft: "5px",
                          }
                        : { top: "0", left: "100%", marginLeft: "5px" }),
                    }}
                    className="color-picker-wrapper"
                  >
                    <Colorpicker
                      color={hexValue}
                      hexValue={hexValue}
                      onChange={handleColorChange}
                      isDragging={isDragging}
                      setIsDragging={setIsDragging}
                      setHexValue={setHexValue}
                      item={contextMenu.item}
                      setShowColorPicker={setShowColorPicker}
                      closeContextMenu={closeContextMenu}
                      changeBackgroundColor={changeBackgroundColor}
                    />
                  </div>
                )}
              </>
            )}
            {contextMenu.item?.type === fileType[0] && (
              <>
                <div className="flex w-full items-center gap-2 px-3 py-2 text-sm bg-gray-800/95 rounded-md">
                  <FaKeyboard className="text-gray-400" size={12} />
                  <input
                    type="text"
                    placeholder={
                      contextMenu.item.shortcut
                        ? contextMenu.item.shortcut
                        : "Set shortcut key (0-9)"
                    }
                    ref={setShortCutFileRef}
                    maxLength={1}
                    className="w-full bg-transparent text-white focus:outline-none"
                    // value={contextMenu.item.shortcut || ""}
                    onChange={(e) => {
                      const key = e.target.value.toLowerCase();
                      if (key.length === 1 && key.match(/[0-9]/i)) {
                        const isShortcutTaken = folders.some(
                          (folder) => folder.shortcut === key
                        );

                        if (
                          isShortcutTaken ||
                          user?.defaultFolderShortcut === key
                        ) {
                          dispatch(
                            setErrorAlert("This shortcut is already in use")
                          );
                          return;
                        }

                        dispatch(
                          setShortCut({ item: contextMenu.item, shortcut: key })
                        );

                        if (contextMenu?.item?.id === "default-folder") {
                          let data = {
                            defaultFolderShortcut: key,
                          };
                          dispatch(setUserShortcut(key));
                          dispatch(getFoldersFromLocalStorage());
                          dispatch(update_user_thunk({ data, token }));
                          closeContextMenu();
                        } else {
                          let data = {
                            id: contextMenu.item.id,
                            shortcut: key,
                          };
                          // if (contextMenu.item.type === fileType[0]) {
                          //   dispatch(setFiles(contextMenu.item.parentId));
                          // }

                          dispatch(update_shortcut_thunk({ data, token }));
                          closeContextMenu();
                        }
                      }
                    }}
                  />
                </div>
                {(contextMenu.item.shortcut ||
                  (contextMenu.item.id === "default-folder" &&
                    user?.defaultFolderShortcut)) && (
                  <button
                    onClick={handleRemoveShortcut}
                    className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-gray-700/50 bg-gray-800/95 text-yellow-400 rounded-md transition-colors"
                  >
                    <FaTimes className="text-yellow-400" size={12} />
                    Remove Shortcut
                  </button>
                )}
              </>
            )}
            {contextMenu?.item?.id !== "default-folder" && (
              <>
                <button
                  onClick={() => {
                    setRenameId(contextMenu.item.id);
                    setRenameText(
                      contextMenu.item.name || contextMenu.item.title
                    );
                  }}
                  className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-gray-700/50 bg-gray-800/95 rounded-md transition-colors"
                >
                  <FaFile className="text-gray-400" size={12} />
                  Rename
                </button>
                <button
                  onClick={() => handleDelete(contextMenu.item)}
                  className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-gray-700/50 bg-gray-800/95 text-red-400 rounded-md transition-colors"
                >
                  <FaFile className="text-red-400" size={12} />
                  Delete
                </button>
              </>
            )}
          </>
        )}
      </motion.div>
      {showModal && (
        <div className="fixed h-screen w-screen bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-gray-800 px-auto py-6 rounded-2xl shadow-2xl w-[90vw] max-w-md">
            <div className="flex w-full justify-between items-center mb-6">
              <div className="text-transparent">
                <FaTimes size={24} />
              </div>
              <h2 className="text-white text-xl font-semibold">
                Choose a Color
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-white bg-transparent hover:text-red-400 transition"
              >
                <FaTimes size={24} />
              </button>
            </div>

            <div className="flex justify-center items-center">
              <Colorpicker
                color={hexValue}
                hexValue={hexValue}
                onChange={handleColorChange}
                isDragging={isDragging}
                setIsDragging={setIsDragging}
                setHexValue={setHexValue}
                item={contextMenu.item}
                setShowColorPicker={setShowColorPicker}
                closeContextMenu={() => setShowModal(false)}
                changeBackgroundColor={changeBackgroundColor}
              />
            </div>

            <div className="mt-4">
              {/* <input
             type="text"
             value={hexValue}
             readOnly
             className="w-full bg-gray-700 text-white text-center py-2 rounded-lg border border-gray-600 focus:outline-none"
           /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
